import React, { useEffect, useState } from 'react';
import { Row, Col, Select, Tag, Card, Divider } from 'antd';
import { store } from 'utils/httpUtil';

const { Option } = Select;

const TerminalDropdown = ({ terminals = [], setSelectedSerials, selectedSerials }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const fetchMerchantDetail = async id => {
    setLoading(true);
    try {
      const response = await store(`terminals/v1/terminals/dropdown`, { id, status: 'REGISTERED' });
      if (response?.data?.message === 'SUCCESS') {
        setData(response.data.data);
      } else {
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchMerchantDetail();
  }, []);
  const handleChange = (mmsId, value) => {
    setSelectedSerials(prev => {
      const existingIndex = prev.findIndex(item => item.mmsId === mmsId);
      if (existingIndex !== -1) {
        const updated = [...prev];
        updated[existingIndex] = { ...updated[existingIndex], serialNumber: value };
        return updated;
      } else {
        return [...prev, { mmsId, serialNumber: value }];
      }
    });
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
      }}
    >
      {/* <Row
        style={{
          fontWeight: 'bold',
          paddingBottom: 8,
        }}
      >
        <Col xs={6}>MMS ID</Col>
        <Col xs={6}>Serial Number</Col>
        <Col xs={6}>Card Switch Info</Col>
        <Col xs={6}>PAP Configs</Col>
      </Row> */}

      {terminals.map((t, index) => (
        <>
          <Row
            key={t.mmsId}
            style={{
              padding: '12px 0',
            }}
          >
            <Col xs={6}>MMSID : {t?.mmsId}</Col>
            <Col xs={6} key={t?.mmsId}>
              <Select
                style={{ width: '100%' }}
                placeholder="Select serial"
                value={
                  selectedSerials.find(item => item.mmsId === t.mmsId)?.serialNumber ||
                  t?.serialNumber ||
                  undefined
                }
                onChange={value => handleChange(t.mmsId, value)}
                showSearch
                optionFilterProp="children"
              >
                {data?.map(opt => (
                  <Option key={opt.switchTerminalId} value={opt.terminalSerialNumber}>
                    {`${opt.terminalSerialNumber} (${opt.switchTerminalId})`}
                  </Option>
                ))}
              </Select>
            </Col>
          </Row>

          <Row gutter={[12, 12]}>
            {t.cardSwitchInfos?.length > 0 &&
              t.cardSwitchInfos.map((c, i) => (
                <Col xs={6}>
                  <Card size="small" title={`CARD`}>
                    <div>
                      <strong>Switch ID:</strong> {c.switchId || '-'}
                    </div>
                    <div>
                      <strong>MID:</strong> {c.mid || '-'}
                    </div>
                    <div>
                      <strong>TID:</strong> {c.tid || '-'}
                    </div>
                    <div>
                      <strong>Surcharge:</strong> {c.surchargeEnabled ? 'Enabled' : 'Disabled'}
                    </div>
                  </Card>
                </Col>
              ))}
            {t.qrConfigInfos?.length > 0 &&
              t.qrConfigInfos.map((q, i) => (
                <Col xs={6}>
                  <Card size="small" title={`QR`}>
                    <div>
                      <strong>Network:</strong> {q.network}
                    </div>
                    <div>
                      <strong>MID:</strong> {q.mid}
                    </div>
                    <div>
                      <strong>TID:</strong> {q.tid}
                    </div>
                  </Card>
                </Col>
              ))}
            {t.mnoConfigInfos?.length > 0 &&
              t.mnoConfigInfos.map((q, i) => (
                <Col xs={6} key={i}>
                  <Card size="small" title={`MNO`}>
                    <div>
                      <strong>Network:</strong> {q.network}
                    </div>
                    <div>
                      <strong>MID:</strong> {q.mid}
                    </div>
                    <div>
                      <strong>TID:</strong> {q.tid}
                    </div>
                    <div>
                      <strong>Surcharge:</strong> {q.surchargeEnabled ? 'Enabled' : 'Disabled'}
                    </div>
                  </Card>
                </Col>
              ))}
            {t.cashConfigInfos?.length > 0 &&
              t.cashConfigInfos.map((q, i) => (
                <Col xs={6}>
                  <Card size="small" title={`CASH`}>
                    <div>
                      <strong>Network:</strong> {q.network}
                    </div>
                    <div>
                      <strong>MID:</strong> {q.mid}
                    </div>
                    <div>
                      <strong>TID:</strong> {q.tid}
                    </div>
                  </Card>
                </Col>
              ))}
          </Row>
          {terminals.length !== index + 1 && <Divider />}
        </>
      ))}
    </div>
  );
};

export default TerminalDropdown;
